"use client";

import type { ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/shared/ui/collapsible";
import { cn } from "@/shared/lib/utils";

interface BoardFilterGroupProps {
  title: string;
  /** Сколько значений выбрано в группе — видно и у свёрнутой. */
  count: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Классы сетки чипов: число колонок у каждой группы своё. */
  gridClassName: string;
  children: ReactNode;
}

export function BoardFilterGroup({ title, count, open, onOpenChange, gridClassName, children }: BoardFilterGroupProps) {
  return (
    <Collapsible open={open} onOpenChange={onOpenChange} className="py-2.5">
      <CollapsibleTrigger className="flex w-full items-center gap-2 rounded-md text-left outline-none focus-visible:ring-2 focus-visible:ring-ring/50">
        <span className="font-logo text-[11px] uppercase tracking-[1.2px] text-muted-foreground">{title}</span>
        {count > 0 && (
          <span className="inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-highlight-soft px-1.5 text-[10px] font-bold text-highlight">
            {count}
          </span>
        )}
        <ChevronDown
          aria-hidden
          className={cn("ml-auto size-4 opacity-55 transition-transform duration-200", !open && "-rotate-90")}
        />
      </CollapsibleTrigger>
      <CollapsibleContent className="data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:slide-in-from-top-1">
        <div className={cn("grid gap-1.5 pt-2.5", gridClassName)}>{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
}
